import React from 'react';

export const ShutterRevealFrame = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 87 87"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={43.5} cy={43.5} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.941}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M24.1 92.5H.3V15.8l35.4 23.8-.8.6 3 52.3z"
        />
        <path fill="#ecf7f9" d="M62.1 31.9l-41.9-26h-5.8L60 34.8z" />
        <path fill="#c8dfeb" d="M14.4 5.9H-.4l55.8 36.3 8.1-5.4z" />
        <path
          fill="#414142"
          stroke="#241f20"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M57.6 39.5v-5.1l4.3 2.8-1.2.8"
        />
        <path
          fill="none"
          stroke="#233762"
          strokeWidth={0.941}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M37.9 92.5H24.1L.3 73.5"
        />
        <g strokeLinecap="round" strokeLinejoin="round">
          <path
            fill="#414142"
            stroke="#241f20"
            strokeWidth={0.772}
            d="M69.7 42.2l-12.1-7.8 5.4-3 12 7.3"
          />
          <path
            fill="#bbbebf"
            stroke="#233762"
            strokeWidth={0.941}
            d="M54.3 52.5v40h32V74.1l-32-21.6L75 38.7l11.3 6.7v28.7"
          />
        </g>
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.941}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M54.1 52.5L34.9 40.2l9.7-6.1 18.9 12.3zM35.7 39.6L.3 15.8V6.5l43.2 28zM34.9 40.2l3 52.3h16.4l-.2-40zM.3 41.7l36.1 25.8M.3 56.7l37.2 28.6"
        />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.941}
          strokeMiterlimit={10}
          d="M57.2 40.2l-1.7 1 8 5.2 6.2-4.2-7.8-5"
        />
        <path
          d="M56.6 40.4l1.6 1 4.1-2.6-2-.9s-3.6 1.8-3.7 2.5z"
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.941}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.6 41.1c.3-.7 2.9-2.5 4.1-2.5"
          fill="none"
          stroke="#233762"
          strokeWidth={0.47}
          strokeMiterlimit={10}
        />
      </g>
      <circle
        cx={43.5}
        cy={43.5}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
